export default __webpack_public_path__ + "static/media/school_design_crossbag.58363f22.png";